import { sidebarKeys } from '@terminal/components/sidebar/utils/navigation-utils';
import { create } from '@terminal/utils/store/createStore';

export const SIDEBAR_CLOSED_WIDTH = '34px';
export const SIDEBAR_EXPANDED_WIDTH = '100px';

export interface AppStore {
  isSidebarExpanded: boolean;
  sidebarExpandConfig: Record<string, boolean>;
  setSidebarExpanded: (value: boolean) => void;
  setSidebarExpandConfig: (value: Record<string, boolean>) => void;
}

export const useApp = create<AppStore>(set => ({
  isSidebarExpanded: true,
  sidebarExpandConfig: {
    [sidebarKeys.alfred]: true,
    [sidebarKeys.expMobileAlfred]: false,
    [sidebarKeys.settings]: true,
    [sidebarKeys.screener]: true,
    [sidebarKeys.watchlist]: true,
    [sidebarKeys.quickAnalysis]: false,
    [sidebarKeys.document]: false,
    [sidebarKeys.insightFeed]: true,
  },
  setSidebarExpanded: (value: boolean) => set({ isSidebarExpanded: value }),
  setSidebarExpandConfig: (value: Record<string, boolean>) =>
    set({ sidebarExpandConfig: value }),
}));
